import EnumInput from './EnumInput';
import { ModeOfTransport, TripType } from '../data/FrontendTypes';
import * as Car from '../data/Car';
import * as Train from '../data/Train';
import * as Bike from '../data/Bike';
import CloseIcon from '@mui/icons-material/Close';

type Props = {
    id: number;
    value: TripType;
    setValue: (updatedTrip: TripType) => void;
    toCustomer: boolean;
    deleteSelf: () => void;
}

export default function Trip({ value, setValue, toCustomer, deleteSelf, id }: Props) {

    function switchMOT(newMOT: ModeOfTransport): void {
        if (newMOT === value.mot) return;

        if (newMOT === ModeOfTransport.CAR) {
            setValue(Car.createTrip(toCustomer))
        } else if (newMOT === ModeOfTransport.TRAIN) {
            setValue(Train.createTrip(toCustomer))
        } else if (newMOT === ModeOfTransport.BIKE) {
            setValue(Bike.createTrip(toCustomer)) 
        }
    }

    return (
        <>
            <button className='remove-trip button-transparent' onClick={deleteSelf}>
                <CloseIcon/>
            </button>
            <div className="anfahrt">
                <EnumInput
                    enumType={ModeOfTransport}
                    value={value.mot}
                    onChange={(clickedMOT) => switchMOT(clickedMOT)}
                />
                <p className='doppelpunkt'>:</p>
                <ModeOfTransportConfigurer value={value} setValue={setValue} id={id} toCustomer={toCustomer} deleteSelf={deleteSelf}/>
            </div>
        </>
    );
}

function ModeOfTransportConfigurer({value, setValue}: Props) {
    switch (value.mot) {
        case ModeOfTransport.CAR:
            return <Car.Component value={value} setValue={setValue}/>
        case ModeOfTransport.TRAIN:
            return <Train.Component value={value} setValue={setValue}/>
        case ModeOfTransport.BIKE:
            return <Bike.Component value={value} setValue={setValue}/>
    }
}
